/** @format */

import {ButtonProps} from '@mui/material';

import {Root} from './styles';

const SimpleButton = (props: ButtonProps) => {
  return <Root {...props} />;
};

export {SimpleButton};
